import React from 'react';
import clsx from 'clsx';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import { amber, green } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import WarningIcon from '@mui/icons-material/Warning';
import { withStyles } from '@mui/styles';

import PropTypes from 'prop-types';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const styles = (theme) => ({
  success: {
    backgroundColor: green[600],
  },
  error: {
    backgroundColor: theme.palette.error.dark,
  },
  info: {
    backgroundColor: theme.palette.primary.main,
  },
  warning: {
    backgroundColor: amber[700],
  },
  icon: {
    fontSize: 20,
  },
  closeButton: {
    color: theme.palette.common.white,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'break-spaces',
  },
});

class Notifier extends React.Component {
  static success = (message) => {
    Notifier.instance.setState({ open: true, variant: 'success', message });
  };

  static info = (message) => {
    Notifier.instance.setState({ open: true, variant: 'info', message });
  };

  static warning = (message) => {
    Notifier.instance.setState({ open: true, variant: 'warning', message });
  };

  static error = (message) => {
    Notifier.instance.setState({ open: true, variant: 'error', message });
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      variant: 'info',
    };
    if (!Notifier.instance) {
      Notifier.instance = this;
    }
  }

  handleClick = () => {
    Notifier.instance.setState({ open: true });
  };

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    Notifier.instance.setState({ open: false });
  };

  render() {
    const { classes, position, autoHideDuration } = this.props;
    const { variant } = this.state;
    const Icon = variantIcon[variant];

    return (
      <Snackbar
        anchorOrigin={position}
        open={this.state.open}
        autoHideDuration={
          this.state.message
            ? this.state.message.length > 105
              ? this.state.message.length > 170
                ? 20000
                : 10000
              : autoHideDuration
            : autoHideDuration
        }
        onClose={this.handleClose}>
        <SnackbarContent
          className={classes[variant]}
          aria-describedby="notifier-snackbar"
          message={
            <span id="notifier-snackbar" className={classes.message}>
              <Icon className={clsx(classes.icon, classes.iconVariant)} />
              {this.state.message}
            </span>
          }
          action={[
            <IconButton
              key="close"
              aria-label="close"
              className={classes.closeButton}
              color="inherit"
              onClick={this.handleClose}>
              <CloseIcon className={classes.icon} />
            </IconButton>,
          ]}
        />
      </Snackbar>
    );
  }
}

Notifier.propTypes = {
  autoHideDuration: PropTypes.number,
  classes: PropTypes.object.isRequired,
  position: PropTypes.shape({
    vertical: PropTypes.oneOf(['top', 'bottom']),
    horizontal: PropTypes.oneOf(['left', 'right']),
  }),
};

Notifier.defaultProps = {
  autoHideDuration: 5000,
  position: {
    vertical: 'top',
    horizontal: 'right',
  },
};

export default withStyles(styles)(Notifier);
